import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vantEnLocale from 'vant/es/locale/lang/en-US' // vant-ui lang
import vantZhLocale from 'vant/es/locale/lang/zh-CN'// vant-ui lang
import enUSLocale from '@/lang/en-US/index' // 业务英文
import zhCNLocale from '@/lang/zh-CN/index' // 业务简体中文

Vue.use(VueI18n)

const numberFormats = {
  'zh-CN': {
    currency: {
      style: 'currency',
      currency: 'CNY'
    }
  },
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  }
}

const setDateTimeFormats = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  },
  long: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric'
  }
}

const dateTimeFormats = {
  'zh-CN': setDateTimeFormats,
  'en-US': setDateTimeFormats
}

const messages = {
  'zh-CN': {
    ...vantZhLocale,
    ...zhCNLocale
  },
  'en-US': {
    ...vantEnLocale,
    ...enUSLocale
  }
}

export default new VueI18n({
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: messages,
  dateTimeFormats,
  numberFormats
})
